import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { X, Loader2, PlusCircle } from "lucide-react";

const bugun = () => new Date().toISOString().slice(0, 10);

export default function QuickPlanModal({ kalip, aciklama, makina, eksik, onClose, onCreated }) {
  const [form, setForm] = useState({
    kalip_kodu: kalip || "",
    aciklama: aciklama || "",
    makina: makina || "",
    kalip_degisim_tarihi: bugun(),
    sekillenecek_adet: eksik ? String(Math.round(eksik)) : "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    if (!form.kalip_kodu || !form.makina || !form.kalip_degisim_tarihi || !form.sekillenecek_adet) {
      toast.error("Makina, tarih ve şekillenecek adet zorunludur.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/entity/sekillendirme_plani", {
        kalip_kodu: form.kalip_kodu,
        aciklama: form.aciklama,
        makina: form.makina,
        kalip_degisim_tarihi: form.kalip_degisim_tarihi,
        sekillenecek_adet: Number(form.sekillenecek_adet),
      });
      toast.success("Şekillendirme planı oluşturuldu.");
      onCreated && onCreated();
      onClose();
    } catch (e) {
      toast.error("Plan oluşturulamadı.");
    } finally {
      setSaving(false);
    }
  };

  const inp = "w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-amber-600";

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/50 p-4 overflow-y-auto" onMouseDown={onClose} data-testid="quick-plan-modal">
      <div className="bg-white rounded-md shadow-xl w-full max-w-lg my-8" onMouseDown={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-zinc-200 px-5 py-3">
          <div className="flex items-center gap-2">
            <PlusCircle size={18} className="text-amber-600" />
            <h3 className="font-head font-bold text-base">Hızlı Şekillendirme Planı</h3>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-zinc-900" data-testid="quick-plan-kapat"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-zinc-600 mb-1 uppercase tracking-wide">Kalıp Kodu</label>
            <input value={form.kalip_kodu} readOnly className={`${inp} bg-zinc-50 mono font-semibold`} data-testid="quick-kalip" />
          </div>
          {form.aciklama && (
            <div>
              <label className="block text-xs font-semibold text-zinc-600 mb-1 uppercase tracking-wide">Açıklama</label>
              <input value={form.aciklama} readOnly className={`${inp} bg-zinc-50`} />
            </div>
          )}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-zinc-600 mb-1 uppercase tracking-wide">Makina <span className="text-red-500">*</span></label>
              <input value={form.makina} onChange={(e) => set("makina", e.target.value)} className={inp} data-testid="quick-makina" placeholder="Makina adı" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-zinc-600 mb-1 uppercase tracking-wide">Bağlanma Tarihi <span className="text-red-500">*</span></label>
              <input type="date" value={form.kalip_degisim_tarihi} onChange={(e) => set("kalip_degisim_tarihi", e.target.value)} className={inp} data-testid="quick-tarih" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-zinc-600 mb-1 uppercase tracking-wide">Şekillenecek Adet <span className="text-red-500">*</span></label>
            <input type="number" value={form.sekillenecek_adet} onChange={(e) => set("sekillenecek_adet", e.target.value)} className={inp} data-testid="quick-adet" />
            {eksik ? <p className="text-[11px] text-zinc-400 mt-1">Önerilen: eksik stok kadar ({Math.round(eksik).toLocaleString("tr-TR")})</p> : null}
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 border-t border-zinc-200 px-5 py-3">
          <button onClick={onClose} className="text-sm text-zinc-600 hover:text-zinc-900 px-3 py-2" data-testid="quick-iptal">İptal</button>
          <button onClick={submit} disabled={saving} data-testid="quick-olustur"
            className="flex items-center gap-1.5 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-4 py-2 rounded-sm disabled:opacity-60">
            {saving ? <Loader2 size={15} className="animate-spin" /> : <PlusCircle size={15} />} Plan Oluştur
          </button>
        </div>
      </div>
    </div>
  );
}
